import { render } from "./Tts.vue?vue&type=template&id=2105ff20"
import script from "./Tts.vue?vue&type=script&lang=js"
export * from "./Tts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__